import React from 'react';
import styled from 'styled-components';
import { Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { GridNumbers } from '../../utils';
import { verticalGutter, breakpoints } from '../../styles';

const AGIRepStyled = styled(Grid)`
  &.ui.grid {
    margin-top: ${verticalGutter * 1.5};
    @media (min-width: ${breakpoints.tablet}) {
      text-align: left;
    }
  }
`;

const AGIRep = props => {
  const { reps, handleEmailClick } = props;
  const centered = reps && reps.length === 1;

  // eslint-disable-next-line react/prop-types
  const renderRep = ({ givenName, lastName, phone, email }, idx) => (
    <Grid.Column
      as="p"
      key={idx}
      className="text--lead"
      mobile={GridNumbers.base}
      tablet={GridNumbers.half}
      computer={GridNumbers.half}
      data-testid={`rep-item-${idx}`}
    >
      {givenName && (
        <span data-testid={`rep-item-name-${idx}`}>
          {givenName} {lastName}
          <br />
        </span>
      )}
      {phone && (
        <a
          href={`tel:${phone}`}
          title={phone}
          className="link--text"
          data-testid={`rep-item-phone-${idx}`}
        >
          {phone}
          <br />
        </a>
      )}
      {email && (
        <span
          onClick={handleEmailClick}
          className="text--wrap"
          data-testid={`rep-item-email-${idx}`}
        >
          <a href={`mailto:${email}`} title={email}>
            {email}
          </a>
        </span>
      )}
    </Grid.Column>
  );

  return (
    <AGIRepStyled className="agirep" textAlign={centered ? 'center' : null}>
      {reps && reps.map(renderRep)}
    </AGIRepStyled>
  );
};

AGIRep.propTypes = {
  handleEmailClick: PropTypes.func.isRequired,
  reps: PropTypes.arrayOf(
    PropTypes.shape({
      email: PropTypes.string,
      phone: PropTypes.string,
      givenName: PropTypes.string
    })
  ).isRequired
};

export default AGIRep;



// WEBPACK FOOTER //
// ./src/components/AGIRep/AGIRep.js